"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectHideDeletedItemsOption')(function selectHideDeletedItemsOption(hideDeletedItems, state) {
    var optionState = state.optionState;
    optionState.hideDeletedItems = hideDeletedItems;
}));
//# sourceMappingURL=selectHideDeletedItemsOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-conversations-option/lib/actions/selectHideDeletedItemsOption.js
// module id = 5068
// module chunks = 2